import { Grid } from '@/components/ui/layout/layout';

import { deltaLabel } from './usage-format';
import { UsageStatTile } from './UsageStatTile';

import type { TeamUsageTotals } from '../../team.types';

const TILES: Array<[string, keyof TeamUsageTotals]> = [
  ['Chat messages', 'chat_messages'],
  ['Integration actions', 'integration_actions'],
  ['Routine runs', 'routine_runs'],
  ['Meetings', 'meetings'],
];

export function UsageActivityTotals({
  totals,
  previousTotals,
  days,
}: {
  totals: TeamUsageTotals;
  previousTotals: TeamUsageTotals | undefined;
  days: number;
}) {
  return (
    <Grid className="grid-cols-2 gap-3 md:grid-cols-4">
      {TILES.map(([label, key]) => {
        const change = previousTotals
          ? deltaLabel(totals[key], previousTotals[key])
          : null;
        return (
          <UsageStatTile
            key={key}
            value={totals[key]}
            label={label}
            delta={
              change
                ? { label: change, tooltip: `vs previous ${days} days` }
                : null
            }
            className="bg-surface"
          />
        );
      })}
    </Grid>
  );
}
